export default "__VITE_ASSET__DYxwt0lG__"